import "animate.css";
import "../scss/styles.scss";

if (document.getElementById("ticker__item")) {
  const ticker__item = document.getElementById("ticker__item");

  const animate = (element, position) => {
    element.style.transform = `translateX(${position}px)`;
  };

  document.addEventListener("scroll", function () {
    var lastKnownScrollPosition = window.scrollY;

    window.requestAnimationFrame(function () {
      animate(ticker__item, lastKnownScrollPosition * -0.4);
    });
  });
}

jQuery(($) => {
  $("#pricing-date").on("change", function () {
    const date = $(".pricing-date").val();
    const locationID = $(".pricing .row")
      .attr("class")
      .split(" ")[2]
      .split("-")[1];

    $.ajax({
      type: "POST",
      dataType: "html",
      url: ajax_posts.ajaxurl,
      data: {
        id: locationID,
        date: date,
        action: "pricing_location_ajax",
      },
      beforeSend: function (jqXHR) {
        $(".pricing-rows").addClass("loading");
      },
      success: function (data) {
        if (data) {
          $(".pricing-rows .right").html(data);
          $(".price-display.adults-unlimited").counter(0);
          $(".price-display.adults-single").counter(0);

          setTimeout(function () {
            $(".pricing-rows").removeClass("loading");
          }, 1000);
        }
      },
      afterSend: function (jqXHR) {
        console.log(jqXHR);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
      },
    });
  });

  /****************** PLAY VIDEO ******************/

  if (window.innerWidth < 1024 && $(".hero video").length > 0) {
    var video = $(".hero video")[0]; // Get the video element
    if (video.hasAttribute("autoplay")) {
      setTimeout(function () {
        video.play(); // Play the video after a delay of 5 seconds
        video.muted = true;
      }, 3000);
    }
  }

  /****************** POPUP ******************/

  $(".popup-button, .close-popup-icon").on("click", function () {
    const classList = $(this).attr("class").split(" ");
    $(`#${classList[1]}`).toggleClass("show");

    $("body").addClass("is--popped");
  });

  if ($(".promo-popup").length > 0) {
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".promotion-interior-copy").length) {
        $(".promo-popup.show").removeClass("show");
        $("body").removeClass("is--popped");
        console.log("clicked");
      }
    });
  }

  /****************** LOADER ******************/

  $(window).on("load", function (e) {
    $("#loader").fadeToggle({ display: "none" }, "slow");
  });

  /****************** MENU CATEGORY ******************/

  $(".menu-tabs").on("click", "li", function () {
    const classList = $(this).attr("class").split(" ");

    if (classList[0]) {
      $(".menu-tabs .nav-tabs li").removeClass("active");
      $("#menu-content .menu-row .menu-section").removeClass("active");

      $(`#menu-content .menu-row .menu-section.${classList[0]}`).addClass(
        "active",
      );
      $(`.menu-tabs .nav-tabs li.${classList[0]}`).addClass("active");
    }
  });

  /****************** IMAGE BLOCKS ******************/

  $(".image-blocks").on("click", ".cell", function () {
    $(".image-blocks .cell").removeClass("is-active");
    $(".blocky-image").removeClass("is-active");
    $(this).toggleClass("is-active");

    const classList = $(this).attr("class");
    const theClasses = classList.split(" ");
    const theClass = theClasses[1];
    $(`.blocky-image.${theClass}`).toggleClass("is-active");
  });

  /****************** HAMBURGERS MENU ******************/

  $("#header").on("click", "button.navbar-toggler", function () {
    $(this).toggleClass("is-active");
    $("main#main").toggleClass("is--open");
    $("nav#header").toggleClass("menu-open");
    $("body").toggleClass("is--open");
  });

  /****************** ACCORDIONS ******************/

  $(".accord:has(div ul li.active)").addClass("active");

  $(".accord .header").on("click", function () {
    $(this).parent().toggleClass("active");
    $(this).siblings().toggleClass("spacing");
  });

  $(".accord .answer").on("click", function () {
    $(this).parent().toggleClass("active");
    $(this).toggleClass("spacing");
  });

  /****************** LOCATION ******************/

  $(".location-images .icon-column").on("click", ".icon-embedded", function () {
    $(".location-images > *").removeClass("active");
    $(".location-images .icon-column .icon-embedded").removeClass("active");
    $(this).addClass("active");

    const selectedClass = $(this).attr("class").split(" ")[1].split("-")[1];
    $(`.location-images .embedded-${selectedClass}`).addClass("active");
  });

  /****************** TOOLTIP HOVER ******************/

  var hoverOrClick = function () {
    $(".schedule-direction .schedule .tooltip-container").toggleClass("active");
    if ($(".schedule .show-hours").position().top > 20) {
      $(".schedule-direction .schedule .tooltip-container").css("top", "70px");
    }
    $(".schedule-direction .schedule .tooltip-container").css(
      "left",
      $(".schedule .show-hours").position().left - 110 + 6,
    );
  };

  var clickClack = function () {
    $(this).find(".tooltip-container").toggle("active");
    $(this).find(".tooltip-container").css("top", 15);
    $(this).find(".tooltip-container").css("left", "0");
  };

  var clickOrHover = function () {
    $(this).find(".tooltip-container").toggle("active");
  };

  $(".information .show-hours").click(hoverOrClick);
  $(".information.information-hours").click(clickClack);

  $(".info-content.savor .info-icon").on("click", function () {
    const parentPackage = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .attr("class")
      .split(" ")[5];

    $(`.${parentPackage} .tooltip-container`).toggle("active");
  });

  var newClick = function () {
    $(".information.information-hours .tooltip-container").toggleClass(
      "active",
    );
    if ($(".information .show-hours").position().top > 20) {
      $(".information.information-hours .tooltip-container").css("top", "50px");
    }
    let leftOffset = $(".information .show-hours").position().left - 110 + 6;
    $(".information.information-hours .tooltip-container").css(
      "left",
      `min(calc(100% - 180px), ${leftOffset}px)`,
    );
  };

  $(".schedule-direction .schedule").click(hoverOrClick);

  $(".information.information-hours").click(newClick);

  $(".course-location").click(clickOrHover);

  if ($(".location-hero").length > 0) {
    $(document).click(function (e) {
      if (!$(e.target).closest(".information-hours").length) {
        $(".information-hours .tooltip-container").removeClass("active");
      }
      if (!$(e.target).closest(".schedule-direction .schedule").length) {
        $(".schedule-direction .schedule .tooltip-container").removeClass(
          "active",
        );
      }
    });
  }

  if ($(".course-location .show-locations").length > 0) {
    $(document).click(function (e) {
      if (!$(e.target).closest(".course-location .show-locations").length) {
        $(".tooltip-container").hide();
      }
    });
  }

  /* if ($(".schedule .schedule-icon").length > 0) {
    $(document).click(function (e) {
      if (!$(e.target).closest(".schedule .schedule-icon").length) {
        $(".tooltip-container").removeClass("active");
      }
    });
  } */
  if ($(".information.information-hours").length > 0) {
    $(document).click(function (e) {
      if (!$(e.target).closest(".information.information-hours").length) {
        $(".tooltip-container").removeClass("active");
      }
    });
  }

  var tool = 0;
  $(".tooltip-disclaimer").on("click", function () {
    tool++;
    $(this).next(".disclaimer").fadeToggle();
  });

  if ($(".tooltip-container.disclaimer").length > 0) {
    $(document).click(function (e) {
      if (!$(e.target).next(".disclaimer").length && tool == 1) {
        tool = 0;

        if ($(".tooltip-container.disclaimer").is(":visible")) {
          $(".disclaimer").fadeToggle();
          console.log("clicked outside");
        }
      }
    });
  }

  /****************** TEXT ANIMATION ******************/

  const animationArrays = [
    "animated--hero",
    "animated--social",
    "animated--image-slider",
    "animated--columns",
    "animated--columns-rows",
    "animated--two-columns",
    "animated--gallery-slider",
    "animated--one-column",
    "animated--courses",
    "animated--two-images",
    "animated--city-changer",
    "animated--find-location",
    "animated--full-image-slider",
    "animated--promotions",
  ];

  //image-blocks
  //accordion
  //location-header
  //promotion-slider

  //mosaic-columns//
  //title-description//

  function checkAnimations(animationArrays) {
    animationArrays.forEach((element) => {
      const animChecker = document.getElementsByClassName(element).length > 0;
      if (animChecker && $(`.${element}`).isInViewport()) {
        setTimeout(() => {
          $(`.${element} > *`).addClass("hidden");
          var i = 1;
          $(`.${element} > *`).each(function () {
            setTimeout(() => {
              $(this).addClass(
                "animate__animated animate__fadeInUp animate__slow",
              );
              $(this).removeClass("hidden");
              $(`.${element}`).removeClass("hidden");
            }, i * 250);
            i++;
          });

          setTimeout(() => {
            if ($(`.${element} > *`).length == 1) {
              $(`.${element}`).removeClass("hidden");
            }
            $(`.${element}`).removeClass(element);
          }, i * 100);
        }, 150);
      }
    });
  }

  /****************** SCROLL ******************/

  let existingParallax = false;
  checkAnimations(animationArrays);
  createParallax();

  function createParallax() {
    if (
      document.getElementById("parallaxtop") &&
      window.innerWidth > 575 &&
      !existingParallax
    ) {
      existingParallax = true;
      parallaxId("parallaxtop");
      parallaxId("parallaxmiddle");
      parallaxId("parallaxbottom");
      $("#parallaxtop").parallax(
        "50%",
        0.35,
        true,
        false,
        false,
        $("#parallaxtop").outerHeight(),
      );
      $("#parallaxmiddle").parallax(
        "50%",
        0.35,
        true,
        false,
        false,
        $("#parallaxmiddle").outerHeight(),
      );
      $("#parallaxbottom").parallax(
        "50%",
        0.35,
        true,
        false,
        false,
        $("#parallaxbottom").outerHeight(),
      );
    }
  }

  $(window).on("resize", () => {
    //run on resize for tablets going into landscape mode
    createParallax();
  });

  $(window).on("resize scroll", () => {
    checkAnimations(animationArrays);
    const scrollPos = $(this).scrollTop();
    if (scrollPos >= $("#header").offset().top) {
      $(".column_one_group").addClass("sticky-side");
    } else {
      $(".column_one_group").removeClass("sticky-side");
    }
  });

  function parallaxId(name) {
    $(`#${name}`).parallax(
      "50%",
      0.55,
      true,
      false,
      false,
      $(`#${name}`).outerHeight(),
    );

    // Default values
    // xpos,
    // speedFactor,
    // outerHeight = true,
    // onlyLoadOnScroll = true,
    // notBackground = false,
    // containerHeight = 0

    if ($(`#${name} .parallax-content`).length > 0) {
      $(`#${name} .parallax-content`).parallax(
        "initial",
        -0.05,
        false,
        false,
        true,
        $(`#${name}`).outerHeight(),
      );
    }

    if ($(`#${name} .floating-1`).length > 0) {
      $(`#${name} .floating-1`).parallax(
        "initial",
        0.15,
        false,
        false,
        true,
        $(`#${name}`).outerHeight(),
      );
    }

    if ($(`#${name} .floating-2`).length > 0) {
      $(`#${name} .floating-2`).parallax(
        "initial",
        0.15,
        false,
        false,
        true,
        $(`#${name}`).outerHeight(),
      );
    }

    if ($(`#${name} .floating-3`).length > 0) {
      $(`#${name} .floating-3`).parallax(
        "initial",
        0.25,
        false,
        false,
        true,
        $(`#${name}`).outerHeight(),
      );
    }

    if ($(`#${name} .floating-4`).length > 0) {
      $(`#${name} .floating-4`).parallax(
        "initial",
        0.25,
        false,
        false,
        true,
        $(`#${name}`).outerHeight(),
      );
    }
  }

  gform.addFilter(
    "gform_datepicker_options_pre_init",
    function (optionsObj, formId, fieldId) {
      //if (formId == 1 && fieldId == 2) {
      optionsObj.minDate = "-0 Y";
      optionsObj.maxDate = "+2 Y";
      //}
      return optionsObj;
    },
  );

  if ($(".info-content.price").length > 0) {
    $(".par .info-content.price span.h3").counter(0);
    $(".birdie .info-content.price span.h3").counter(0);
    $(".eagle .info-content.price span.h3").counter(0);
  }
  if ($(".price-display").length > 0) {
    $(".price-display.adults-unlimited").counter(0);
    $(".price-display.adults-single").counter(0);
  }

  if ($(".page-template-page-sweepstakes #choice_7_6_1").length > 0) {
    $("#choice_7_6_1").prop("checked", true);
  }
});

$.fn.isInViewport = function () {
  const elementTop = $(this).offset().top;
  const elementBottom = elementTop + $(this).outerHeight();

  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.counter = function (start) {
  var $el = this;

  // Remove '$' from the initial value and parse it as a float
  var initialText = parseFloat($el.text().replace("$", ""));

  $el.prop("Counter", start).animate(
    {
      Counter: initialText,
    },
    {
      duration: 1000,
      easing: "swing",
      step: function (now) {
        $el.text("$" + Math.ceil(now));
      },
    },
  );
};
